<div [formGroup]="formGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid">

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'common.name' | translate }}</mat-label>
        <input matInput data-test="FI-Name Deines Yachtclubs / Bootsclub" type="text" formControlName="name">
        <mat-error>{{formGroup.get('name').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.berthCount' | translate }}</mat-label>
        <input matInput data-test="FI-Anzahl der Liegeplätze" type="text" formControlName="numberOfBerths">
        <mat-error>{{formGroup.get('numberOfBerths').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.versionLabel' | translate }}</mat-label>
        <mat-select formControlName="version" data-test="FI-Version">
            <mat-option [value]="BcmVersions.Premium">{{BcmVersions.Premium}}</mat-option>
            <mat-option [value]="BcmVersions.Prestige">{{BcmVersions.Prestige}}</mat-option>
            <mat-option [value]="BcmVersions.Excellent">{{BcmVersions.Excellent}}</mat-option>
        </mat-select>
        <mat-error>{{formGroup.get('version').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'settings.tenantData.address.productType' | translate }}</mat-label>
        <mat-select formControlName="productType" data-test="FS-Produkttyp">
            <mat-option [value]="BcmTenantType.YachtHarbour">
                {{ 'settings.tenantData.address.productTypeYachtHarbour' | translate }}
            </mat-option>
            <mat-option [value]="BcmTenantType.InlandPort">
                {{ 'settings.tenantData.address.productTypeIndustryPort' | translate }}
            </mat-option>
        </mat-select>
        <mat-error>{{formGroup.get('productType').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <div fxFlex="100">
        <mat-checkbox formControlName="isDemo">
            {{ 'workflows.formWidgets.tenant.demoHarbor' | translate }}
        </mat-checkbox>
    </div>

    <ng-container *ngIf="formGroup.get('isDemo').value">
        <app-input-date-time formControlName="isDemoUntil" appearance="fill">
            <label>{{ 'workflows.formWidgets.tenant.demoUntil' | translate }}</label>
        </app-input-date-time>

        <div fxFlex="100">
            <mat-checkbox formControlName="addDemoData">
                {{ 'workflows.formWidgets.tenant.demoDataCreate' | translate }}
            </mat-checkbox>
        </div>
    </ng-container>

    <h3 fxFlex="100">{{ 'workflows.formWidgets.tenant.addressHeading' | translate }}</h3>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.street' | translate }}</mat-label>
        <input matInput data-test="FI-Straße" type="text" formControlName="street">
        <mat-error>{{formGroup.get('street').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="40" floatLabel="always">
        <mat-label>{{ 'person.core.postalCode' | translate }}</mat-label>
        <input matInput data-test="FI-PLZ" type="text" formControlName="postcode">
        <mat-error>{{formGroup.get('postcode').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="60" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.cityLabel' | translate }}</mat-label>
        <input matInput data-test="FI-Stadt" type="text" formControlName="city">
        <mat-error>{{formGroup.get('city').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.countryLabel' | translate }}</mat-label>
        <mat-select formControlName="country" data-test="FI-Land">
            <mat-option [value]="'Deutschland'">{{ 'workflows.formWidgets.tenant.countryGermanyDe' | translate }}</mat-option>
            <mat-option [value]="'Schweiz'">{{ 'workflows.formWidgets.tenant.countrySwitzerlandCh' | translate }}</mat-option>
        </mat-select>
        <mat-error>{{formGroup.get('country').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <h3 fxFlex="100">{{ 'workflows.formWidgets.tenant.contactsHeading' | translate }}</h3>

    <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
        <mat-label>{{ 'person.emailAddresses.email' | translate }}</mat-label>
        <input matInput data-test="FI-E-Mail Adresse" type="text" formControlName="mail">
        <mat-error>{{formGroup.get('mail').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
        <mat-label>{{ 'common.phoneNumber' | translate }}</mat-label>
        <input matInput data-test="FI-Telefonnummer" type="text" formControlName="phone">
        <mat-error>{{formGroup.get('phone').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.website' | translate }}</mat-label>
        <input matInput data-test="FI-Webseite" type="text" formControlName="website">
        <mat-error>{{formGroup.get('website').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <h3 fxFlex="100">{{ 'workflows.formWidgets.tenant.onlineBookingServiceFeeHeading' | translate }}</h3>

    <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.onlineBookingServiceFeeFlat' | translate }}</mat-label>
        <input matInput type="number" step="0.01" min="0" formControlName="onlineBookingServiceFeeFlat">
        <mat-error>{{formGroup.get('onlineBookingServiceFeeFlat').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="50" floatLabel="always">
        <mat-label>{{ 'workflows.formWidgets.tenant.onlineBookingServiceFeePercent' | translate }}</mat-label>
        <input matInput type="number" step="0.01" min="0" formControlName="onlineBookingServiceFeePercent">
        <mat-error>{{formGroup.get('onlineBookingServiceFeePercent').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

</div>
